'use client';

import { c as _c } from "react/compiler-runtime";
import { NavArrowRight, PencilSquare } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Link } from '~/components/Link';
import { PopTip } from '~/components/Tooltip';
import useJourneyData from '~/hooks/useJourneyData';
import { trackEvent } from '~/utils';
import styles from './EditInMapsButton.module.css';
type EditInMapsButtonProps = {
  variant?: 'extraSmall' | 'small';
  context: 'trip_overview' | 'itinerary_heading';
};
function EditInMapsButton(t0) {
  const $ = _c(31);
  const {
    variant: t1,
    context
  } = t0;
  const variant = t1 === undefined ? "small" : t1;
  const t = useTranslations("journey");
  const {
    uniqueId,
    canImportIntoMaps,
    journeyType
  } = useJourneyData();
  const isJourneyGuide = journeyType === "journeyGuide";
  if (!canImportIntoMaps) {
    let t2;
    if ($[0] !== t) {
      t2 = t("edit_places_unavailable_tooltip");
      $[0] = t;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t) {
      t3 = t("edit_places_adjust_label");
      $[2] = t;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t3) {
      t4 = <span className={styles.tooltipLabel}>{t3}</span>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
      t5 = <PopTip content={t2}>{t4}</PopTip>;
      $[6] = t2;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  if (!isJourneyGuide && canImportIntoMaps) {
    const link = `/map/build?journeyId=${uniqueId}`;
    let t2;
    if ($[9] !== context) {
      t2 = () => {
        trackEvent("import_into_maps_click", {
          event_label: `${context}`,
          event_category: "trip_page"
        });
      };
      $[9] = context;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    const track = t2;
    if (variant === "extraSmall") {
      let t3;
      if ($[11] !== t) {
        t3 = t("edit_places");
        $[11] = t;
        $[12] = t3;
      } else {
        t3 = $[12];
      }
      let t4;
      if ($[13] !== t3) {
        t4 = <span>{t3}</span>;
        $[13] = t3;
        $[14] = t4;
      } else {
        t4 = $[14];
      }
      let t5;
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <NavArrowRight decorative={true} strokeWidth={3} />;
        $[15] = t5;
      } else {
        t5 = $[15];
      }
      let t6;
      if ($[16] !== t4) {
        t6 = <div className={styles.extraSmallContent}>{t4}{t5}</div>;
        $[16] = t4;
        $[17] = t6;
      } else {
        t6 = $[17];
      }
      let t7;
      if ($[18] !== link || $[19] !== t6 || $[20] !== track) {
        t7 = <Link href={link} target="_self" onClick={track}>{t6}</Link>;
        $[18] = link;
        $[19] = t6;
        $[20] = track;
        $[21] = t7;
      } else {
        t7 = $[21];
      }
      return t7;
    }
    if (variant === "small") {
      let t3;
      if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <PencilSquare size="small" decorative={true} />;
        $[22] = t3;
      } else {
        t3 = $[22];
      }
      let t4;
      if ($[23] !== t) {
        t4 = t("edit_places");
        $[23] = t;
        $[24] = t4;
      } else {
        t4 = $[24];
      }
      let t5;
      if ($[25] !== t4) {
        t5 = <div className={styles.smallContent}>{t3}{t4}</div>;
        $[25] = t4;
        $[26] = t5;
      } else {
        t5 = $[26];
      }
      let t6;
      if ($[27] !== link || $[28] !== t5 || $[29] !== track) {
        t6 = <Link asButton="secondary" size="extraSmall" href={link} target="_self" onClick={track}>{t5}</Link>;
        $[27] = link;
        $[28] = t5;
        $[29] = track;
        $[30] = t6;
      } else {
        t6 = $[30];
      }
      return t6;
    }
    return null;
  }
}

// CHORE: delete this wrapper and export main component when feature flag no longer needed
function EditInMapsButtonWrapper(t0) {
  const $ = _c(3);
  const {
    variant,
    context
  } = t0;
  const isEnabled = process.env.NEXT_PUBLIC_FF_EDIT_IN_MAPS === "true";
  if (!isEnabled) {
    return null;
  }
  let t1;
  if ($[0] !== context || $[1] !== variant) {
    t1 = <EditInMapsButton variant={variant} context={context} />;
    $[0] = context;
    $[1] = variant;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export { EditInMapsButtonWrapper as EditInMapsButton };